import { Injectable, Injector, TemplateRef } from '@angular/core';

import { DomService } from '../../services/dom.service';
import { extendObject } from '../../util/object-extend';
import { PortalInjector } from '../../portal/portal-injector';
import { ModalComponent } from '../components/modal.component';

export class ModalConfig {
    title: string;
    width?: string;
    message?: string;
    isFull?: boolean;
    isSmall?: boolean;
    isLarge?: boolean;
    loading?: boolean;
    okButtonText?: string;
    hasBackdrop?: boolean;
    cancelButtonText?: string;
    okHandler?: () => {} = null;
    cancelHandler?: () => {} = null;
}

export interface ComponentType<T> {
    new(...args: any[]): T;
}

@Injectable({
    providedIn: 'root',
})

export class ModalService {
    constructor(
        private domService: DomService,
        private injector: Injector
    ) {}

    public open<T>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config: ModalConfig): ModalComponent<T> {
        const componentRef = this.getComponentRef({...{ hasBackdrop: true }, ...config});

        componentRef.instance._setComponent(componentOrTemplateRef);

        return componentRef.instance as ModalComponent<T>;
    }

    private getComponentRef(config: ModalConfig) {
        const injectionTokens = new WeakMap();

        injectionTokens.set(ModalComponent, ModalComponent);

        const injector = new PortalInjector(this.injector, injectionTokens);

        const componentRef = this.domService.attachComponentPortal(ModalComponent, injector);

        componentRef.instance.config = extendObject(new ModalConfig(), config);

        componentRef.instance.afterClosed().subscribe(() => {
            componentRef.destroy();
        });

        return componentRef;
    }
}
